import { Pipe, PipeTransform } from '@angular/core';

// models
import { Product } from '../../planogram/models/product';

@Pipe({
    name: 'tableActiveRow',
    pure: false,
    standalone: true
})
export class TableActiveRowPipe implements PipeTransform {

	transform(element: any): boolean {
		if (Array.isArray(element)) {
			return element.every((product: Product) => product.selected);
		}
		return false;
	}
}
